var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 731,
    viewBox: "0 0 286 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.596 733.536C231.243 676.999 318.211 517.88 244.9 333.7C211.875 243.377 168.416 51.7508 258.781 7.83128",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.513 734.674C221.635 678.17 309.342 519.103 235.189 334.864C201.779 244.514 157.764 52.8483 248.981 8.98885",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.342 731.252C211.99 674.715 298.958 515.596 225.646 331.417C192.621 241.094 149.162 49.4671 239.527 5.54759",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.448 729.629C202.571 673.126 290.278 514.059 216.124 329.82C182.715 239.47 138.7 47.8039 229.916 3.94442",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.89 731.728C192.538 675.191 279.506 516.072 206.195 331.893C173.17 241.57 129.711 49.9432 220.076 6.02366",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.758 730.159C183.406 673.622 270.374 514.503 197.062 330.324C164.037 240 120.578 48.3739 210.943 4.45432",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.488 730.43C174.136 673.893 261.104 514.774 187.793 330.594C154.768 240.271 111.309 48.6444 201.674 4.72483",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.291 729.78C164.939 673.243 251.907 514.124 178.596 329.944C145.57 239.621 102.111 47.9945 192.477 4.07493",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09 729.131C155.738 672.594 242.706 513.475 169.395 329.295C136.369 238.972 92.9102 47.3456 183.275 3.426",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.412 733.277C145.06 676.74 232.028 517.621 158.717 333.442C125.692 243.118 82.2325 51.492 172.598 7.57249",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3271 734.414C135.45 677.911 223.156 518.844 149.003 334.605C115.594 244.255 71.5787 52.589 162.795 8.72957",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1581 730.993C125.806 674.456 212.774 515.337 139.463 331.158C106.438 240.834 62.9785 49.2079 153.344 5.28831",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2646 729.37C116.387 672.867 204.094 513.8 129.941 329.561C96.5313 239.211 52.5162 47.5451 143.733 3.68563",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7069 731.47C106.355 674.933 193.323 515.814 120.012 331.634C86.9865 241.311 43.5274 49.6844 133.893 5.76487",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5702 729.9C97.2181 673.363 184.186 514.244 110.875 330.064C77.8498 239.741 34.3907 48.1146 124.756 4.19505",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3046 730.17C87.9524 673.633 174.92 514.514 101.609 330.335C68.5841 240.012 25.125 48.3851 115.49 4.46555",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1053 729.521C78.7532 672.984 165.721 513.865 92.4101 329.685C59.3849 239.362 15.9258 47.7357 106.291 3.81614",
    stroke: "white",
    strokeWidth: 0.922313
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9061 728.872C69.554 672.334 156.522 513.215 83.2109 329.036C50.1857 238.713 6.72659 47.0863 97.0919 3.16673",
    stroke: "white",
    strokeWidth: 0.922313
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightline);
export default __webpack_public_path__ + "static/media/rightline.6f854391fac760d0d4810329fe045eaa.svg";
export { ForwardRef as ReactComponent };